<template>
  <div
      class="card product-card text-center position-relative"
      :class="cardClasses"
      @click="handleClick"
  >
    <!-- ✅ Badge de sélection uniquement si stock > 0 -->
    <span
        v-if="isSelected && product.stockQuantity > 0"
        class="position-absolute top-0 end-0 m-1 badge bg-success"
    >
      <i class="fe fe-check-circle"></i>
    </span>

    <!-- 🖼️ Image produit -->
    <div class="image-wrapper">
      <img
          :src="product.imageUrl || 'https://www.tiffincurry.ca/wp-content/uploads/2021/02/default-product.png'"
          class="img-fluid p-3"
          :alt="product.name"
      >
    </div>

    <div class="card-body pt-0">
      <h5 class="fw-bold">{{ product.name }}</h5>
      <p class="text-muted small">{{ product.categoryLabel }}</p>
      <p class="fw-bold text-primary">${{ product.referencePrice }}</p>
      <p class="stock-label" :class="stockClass">
        {{ product.stockQuantity > 0 ? product.stockQuantity + ' en stock' : 'Rupture de stock' }}
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ProductCard",
    props: {
      product: Object,
      selected: Boolean
    },
    computed: {
      isSelected() {
        return this.selected;
      },
      stockClass() {
        if (this.product.stockQuantity > 10) return 'text-success';
        if (this.product.stockQuantity > 0) return 'text-warning';
        return 'text-danger';
      },
      cardClasses() {
        return {
          'border-success': this.isSelected && this.product.stockQuantity > 0,
          'out-of-stock': this.product.stockQuantity === 0,
        };
      }
    },
    methods: {
      handleClick() {
        if (this.product.stockQuantity === 0) return; // effet bloquant
        this.$emit("toggle", this.product);
      }
    }
  };
</script>

<style scoped>
.product-card {
  cursor: pointer;
  transition: transform 0.2s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.product-card:hover {
  transform: scale(1.02);
}

.out-of-stock {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: auto;
}

.image-wrapper {
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.image-wrapper img {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
}

.stock-label {
  font-size: 0.85rem;
  margin-top: 0.25rem;
}
</style>
